"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedCostAudienceSizeResultToJSON = exports.FixedCostAudienceSizeResultFromJSONTyped = exports.FixedCostAudienceSizeResultFromJSON = exports.instanceOfFixedCostAudienceSizeResult = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the FixedCostAudienceSizeResult interface.
 */
function instanceOfFixedCostAudienceSizeResult(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFixedCostAudienceSizeResult = instanceOfFixedCostAudienceSizeResult;
function FixedCostAudienceSizeResultFromJSON(json) {
    return FixedCostAudienceSizeResultFromJSONTyped(json, false);
}
exports.FixedCostAudienceSizeResultFromJSON = FixedCostAudienceSizeResultFromJSON;
function FixedCostAudienceSizeResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'totalCapacity': !(0, runtime_1.exists)(json, 'total_capacity') ? undefined : json['total_capacity'],
        'bookedImpressions': !(0, runtime_1.exists)(json, 'booked_impressions') ? undefined : json['booked_impressions'],
        'availableImpressions': !(0, runtime_1.exists)(json, 'available_impressions') ? undefined : json['available_impressions'],
        'likelyToDeliverBudget': !(0, runtime_1.exists)(json, 'likely_to_deliver_budget') ? undefined : json['likely_to_deliver_budget'],
        'salesforceLineItemId': !(0, runtime_1.exists)(json, 'salesforce_line_item_id') ? undefined : json['salesforce_line_item_id'],
    };
}
exports.FixedCostAudienceSizeResultFromJSONTyped = FixedCostAudienceSizeResultFromJSONTyped;
function FixedCostAudienceSizeResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'total_capacity': value.totalCapacity,
        'booked_impressions': value.bookedImpressions,
        'available_impressions': value.availableImpressions,
        'likely_to_deliver_budget': value.likelyToDeliverBudget,
        'salesforce_line_item_id': value.salesforceLineItemId,
    };
}
exports.FixedCostAudienceSizeResultToJSON = FixedCostAudienceSizeResultToJSON;
